import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

const Home = () => {
  const { t } = useTranslation()
  const location = useLocation()

  return (
    <>
      <div className='pt-5 static-root h-100 page-not-found bg-container' style={{ color: '#FFF' }}>
        <h2 className='text-center'>
          <i className='mx-2 fa fa-exclamation-triangle' aria-hidden='true' />
          {location?.state?.title ? t(location?.state?.title) : t('Error')}
        </h2>
        <div className='mt-3 notFound text-center'>
          <p>
            {location?.state?.message ? t(location?.state?.message) : t('Something went wrong. Please try again.')}
          </p>
        </div>
      </div>
    </>
  )
}

export default Home
